import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Pediatrics from './pages/ProductCategories/Pediatrics';
import Gynecology from './pages/ProductCategories/Gynecology';
import Orthopedics from './pages/ProductCategories/Orthopedics';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
  // Use the basename that matches your GitHub Pages repository name
  return (
    <Router>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow pt-24">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/pediatrics" element={<Pediatrics />} />
            <Route path="/products/gynecology" element={<Gynecology />} />
            <Route path="/products/orthopedics" element={<Orthopedics />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
